import HLSPlayer from './HLSPlayer';
import MJPEGPlayer from './MJPEGPlayer';

const VideoPlayer = {
  HLS: HLSPlayer,
  MJPEG: MJPEGPlayer,
};

export default VideoPlayer;
